import {
    Component,
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    inject,
    Input,
    OnInit,
    Output, ViewChild
} from '@angular/core';
import {TranslatePipe} from '../../filters/translate.pipe';
import {CommonModule} from '@angular/common';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import {SymptomListPopoverComponent} from '../symptom-list-popover/symptom-list-popover.component';
import symptomsData from 'src/assets/symptoms.json';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';

@Component({
    standalone: true,
    selector: 'body-model',
    templateUrl: './body-model.component.html',
    imports: [TranslatePipe, CommonModule, SymptomListPopoverComponent]
})

export class BodyModelComponent implements OnInit {
    @ViewChild('popover', { static: false }) popover!: ElementRef;

    private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
    vm: any = undefined;
    rotateBody: boolean = false;
    allSymptoms: any[] = [];
    bodyPartsSymptoms: any[] = [];
    age: number;
    ageInMonths: number;
    sex: string;
    bodyPartSymptomNames: { [key: string]: string[] } = {};
    isPopoverVisible: boolean = false;
    selectedSymptoms: { id: number; name: string, bodyPart: string }[] = []; // This stores all selected symptoms across sessions

    private restService: RestService = inject(RestService);
    private angularHelperService: AngularHelperService = inject(AngularHelperService);

    private ageRanges = {
        m: [
            { range: '0-0', min: 0, max: 0 },
            { range: '1-6', min: 1, max: 6 },
            { range: '7-11', min: 7, max: 11 }
        ],
        y: [
            { range: '1-1', min: 1, max: 1 },
            { range: '2-3', min: 2, max: 3 },
            { range: '4-6', min: 4, max: 6 },
            { range: '7-11', min: 7, max: 11 },
            { range: '12-17', min: 12, max: 17 },
            { range: '18-29', min: 18, max: 29 },
            { range: '30-44', min: 30, max: 44 },
            { range: '45-59', min: 45, max: 59 },
            { range: '60-74', min: 60, max: 74 },
            { range: '75-120', min: 75, max: 120 }
        ]
    };

    @Input() interview: any;

    @Output() selectedSymptomsChange = new EventEmitter<{ id: number; name: string; bodyPart: string  }[]>();


    constructor(private elementRef: ElementRef) {
        this.vm = this;
    }

    ngOnInit(): void {
        this.vm.rotateModel = this.rotateModel;
        this.vm.onBodyPartClick = this.onBodyPartClick;
        this.vm.onPopoverClose = this.onPopoverClose;
        this.vm.bodyPartSymptomNames = this.bodyPartSymptomNames;
        this.vm.onSymptomsSelected = this.onSymptomsSelected;
        this.vm.isBodyPartSelected = this.isBodyPartSelected;
		
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.previsitLocation = true;
		}
		this.vm.iconSuffix = this.vm.previsitLocation ? '-previsit' : '';

        this.vm.rotateBody = false;

        this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
        if (this.vm.params['type'] === 'pre-visit') {
            this.vm.preVisit = true;
            this.getDataForPrevisit();
        } else {
            if(this.vm.interview.selfTest === true) {
                this.getDataForPrevisit();
            }
        }


        this.initializeUserData();
        this.getAllSymptoms();

    }

    rotateModel() {
        this.vm.rotateBody = !this.vm.rotateBody;
    }

    onBodyPartClick(bodyPart: string): void {
        this.vm.bodyPart = bodyPart;
        this.vm.isPopoverVisible = !this.isPopoverVisible;
        this.parseSymptoms(symptomsData);
    }

    onPopoverClose() {
        this.vm.isPopoverVisible = false;
        this.selectedSymptomsChange.emit(this.vm.selectedSymptoms);
    }

    parseSymptoms(data: any) {
        for (let ageCategory in data) {
            const ageRanges = data[ageCategory];
            for (let ageRange in ageRanges) {
                const bodyParts = ageRanges[ageRange];
                for (let part in bodyParts) {
                    const symptoms = new Set<string>();
                    if (bodyParts[part].both) {
                        bodyParts[part].both.forEach((symptomId: string) => symptoms.add(symptomId));
                    }
                    if (bodyParts[part].male && this.vm.male) {
                        bodyParts[part].male.forEach((symptomId: string) => symptoms.add(symptomId));
                    }
                    if (bodyParts[part].female && this.vm.female) {
                        bodyParts[part].female.forEach((symptomId: string) => symptoms.add(symptomId));
                    }

                    if (symptoms) {
                        symptoms.forEach((symptomId: string) => {
                            this.vm.bodyPartsSymptoms.push({
                                ageCategory,
                                ageRange,
                                bodyPart: part,
                                symptomId
                            });
                        });
                    }
                }
            }
        }


        this.vm.bodyPartsSymptoms = this.getSymptomsByAgeRange();
        this.vm.bodyPartSymptomNames = this.extractSymptomNames(this.vm.bodyPart);
    }
    getAllSymptoms(): any {
        var deferred: any = this.angularHelperService.getDeferredPromise();

        var searchParams: any = {};
        if (this.vm.interview.sex) {
            searchParams.sex = this.sex;
        }
        if (this.vm.interview.age) {
            searchParams.ageValue = this.vm.age;
        }
        if (this.vm.preVisit) {
            searchParams.type = 'pre-visit';

        }
        this.restService.getAllSymptoms(searchParams)
            .then((res) => {
                this.allSymptoms = res.map(function(item) { return { id: item.id, name: item.common_name || item.name}; });
                deferred.resolve( this.allSymptoms );
            })
            .catch((err) => {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    }

    initializeUserData() {
        this.age = this.vm.interview.age;
        this.ageInMonths = this.vm.interview.ageInMonths;
        this.sex = this.vm.interview.sex;

        this.vm.male = this.sex == 'male';
        this.vm.female = this.sex == 'female';
        this.vm.child = this.age > 1 && this.age <= 16;
        this.vm.infant = this.age <= 1;
        this.vm.adult = this.age > 16;
    }
    private getSymptomsByAgeRange(): any {
        let userAgeRange;
        let userAgeCategory = this.age < 1 ? "m" : "y";
        let userAge = userAgeCategory === 'm' ? this.ageInMonths : this.age;

        for (const ageRange of this.ageRanges[userAgeCategory]) {
            if (userAge >= ageRange.min && userAge <= ageRange.max) {
                userAgeRange = ageRange.range;
                break;
            }
        }

        return this.vm.bodyPartsSymptoms.filter(item =>
            item.ageCategory === userAgeCategory && item.ageRange === userAgeRange
        );
    }

    private extractSymptomNames(bodyPart: string): any {
        let bodyPartSymptomNames = {};
        let symptomIds = this.vm.bodyPartsSymptoms.filter(item => item.bodyPart === bodyPart);
        bodyPartSymptomNames[bodyPart] = symptomIds
            .map(item => this.getSymptomById(item.symptomId))
            .filter(symptom => symptom !== null)
            .filter((symptom, index, self) =>
                index === self.findIndex(t => t.id === symptom.id)
            );

       return bodyPartSymptomNames;
    }

    private getSymptomById(id: number): { id: number; name: string, bodyPart: string  } | null {
        const symptom = this.allSymptoms.find(s => s.id === id);
        const bodyPart = this.vm.bodyPartsSymptoms.find(bp => bp.symptomId === id);
        return symptom ? { id: symptom.id, name: symptom.name, bodyPart: bodyPart.bodyPart } : null;
    }

    onSymptomsSelected(selectedSymptoms: { id: number; name: string, bodyPart: string }[]): void {
        this.vm.selectedSymptoms = selectedSymptoms;
       this.isBodyPartSelected(this.vm.bodyPart);
    }

    isBodyPartSelected(bodyPart: string): boolean {
        var selectedBodyParts = this.vm.selectedSymptoms.map(symptom => symptom.bodyPart);
        return selectedBodyParts.includes(bodyPart);
    }

    getDataForPrevisit() {
        var deferred: any = this.angularHelperService.getDeferredPromise();

        this.restService.getUserDataForPrevisit()
            .then((res) => {
                deferred.resolve( res);
                this.vm.interview.age = res.age;
                this.vm.interview.sex = res.sex;
                this.initializeUserData();
            })
            .catch((err) => {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.vm.isPopoverVisible = false;
        }
    }


}